export default "__VITE_ASSET__90012224__"